// extracted by mini-css-extract-plugin
export default {"viewTemplatesContainer":"ViewTreatmentPlanTemplate_viewTemplatesContainer__fCii6"};